import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useDidUpdateEffect from '../../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { debounce } from '../../../../helpers/common'
import { Input } from '../../common/input'
import { changeFilter, selectFilter } from '../store/slice'
import { UseI18n } from './../../../../common/hooks/useI18n'
import classes from './index.module.scss'

export const SearchCriteria = () => {
  const dispatch = useDispatch()

  const keyword = useSelector(selectFilter('keyword'))

  const [inputValue, setInputValue] = useState(keyword)

  const handleChangeKeyword = useCallback(
    debounce((keyword) => {
      dispatch(changeFilter({ keyword, page: 1 }))
    }, 700),
    [],
  )

  useDidUpdateEffect(() => {
    handleChangeKeyword(inputValue)
  }, [inputValue])

  return (
    <Element className={classes.searchCriteria}>
      <Input
        noControl
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={UseI18n('screening.SEARCH_SAVED_CRITERIA')}
        prefix={
          <Icon className="icon-search pr1" style={{ color: '#9C9C9C' }} />
        }
        wrapperStyle={{ borderRadius: 2 }}
      />
    </Element>
  )
}
